import React from "react";
import { Link } from "react-router-dom";
import "../../assets/website/css/websiteAd.css";
import webAdImg from "../../assets/website/images/webAd.jpg";
import { useTranslation } from "react-i18next";

const WebsiteAd = () => {
  const { t } = useTranslation();

    return (
      <div className="website-ad-parent-container">
     <h2>{t("website.home.LookingToBuildWebsite")}</h2>
     <p className="">{t("website.home.LookingToBuildWebsiteSubheading")}</p>
     <div className="website-ad-content-wrapper">
     <h4 className="">
            {t("website.home.DriveMoreCustomers")}
          </h4>
          <div className="website-add-left-right-parent-container">
          <div className="website-ad-content-left">
          <p className="">
            {t("website.home.YourWebsiteIsNotJustADigitalBusinessCard")}
          </p>
          <div className="website-ad-button-gray-yellow">
  <Link className="button-gray" to="/website-build-info">{t("website.home.KnowMore")}</Link>
  <Link className="button-yellow" to="/website-build-request">{t("website.home.BuildYourSiteToday")}</Link>
</div>
          </div>
          <div className="website-ad-content-right">
            <img
              src={webAdImg}
              alt="Website build illustration"
              width="280"
              height="280"
              loading="lazy"
              decoding="async"
            />
          </div>
          </div>
        
     </div>
      </div>
    );
  };
  
  export default WebsiteAd;
